// extracted by mini-css-extract-plugin
module.exports = {"Cluster":"BaseSpiderfy_Cluster__2GL9q"};